import axios, { InternalAxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import { message } from 'antd';
import config from './config';
import { TResponse } from '../types/common';
import { getToken } from './utils';
import { useUserStore } from '../store/slices/user';

let sessionExpiredNoticeShown = false;

const axiosInstance = axios.create({
    baseURL: config.apiUrl
});

axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        config.headers.authorization = "Bearer " + getToken();
            // to bypass ngrok warning
            // config.headers["ngrok-skip-browser-warning"] = "2525"
            return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      
        return response;
    },
    (error: AxiosError) => {
        let response: TResponse<any> = {
            success: false,
            message: "Something went wrong",
            code: 500,
            data: null
        };
        if (error.response?.data) {
            const data = error.response.data as Partial<TResponse>;
            response.message = data.message ?? error.message;
            if (Array.isArray(data.errors) && data.errors.length > 0) {
                response.message = data.errors[0].msg;
                response.errors = data.errors;
            }
        } else {
            response.message = error.message;
        }

        // An expired/invalid token doesn't fail loudly on its own — every
        // request just silently 401s, which previously left stale/empty
        // screens up with no indication why. Force a logout so the user
        // lands back on the login screen instead of staring at a blank
        // dashboard wondering if data is missing.
        if (error.response?.status === 401 && useUserStore.getState().isLoggedIn) {
            useUserStore.getState().logout();
            if (!sessionExpiredNoticeShown) {
                sessionExpiredNoticeShown = true;
                message.error("Your session has expired. Please log in again.");
                setTimeout(() => { sessionExpiredNoticeShown = false; }, 3000);
            }
        }

        return Promise.reject(response);
    },
);

export default axiosInstance;